var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBanner),expression:"showBanner"}],attrs:{"id":"cookieNotice"},on:{"click":_vm.clickHandler}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]}),_c('a',{staticClass:"button",attrs:{"href":"#"},on:{"click":_vm.clickHandler}},[_vm._v(_vm._s(_vm.OK))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }